import React, { useState } from "react";
import createNewTicket_image from "../../assets/images/createNewTicket_image.png";
import attachment_pin_02 from "../../assets/icons/attachment_pin_02.png";
import calender_icon from "../../assets/icons/calender_icon.png";

const CreateNewTicket = ({ setNewTicket }) => {
  const [followUp, setFollowUp] = useState("");

  return (
    <>
      <div className="modal-wrapper"></div>
      <div className="modal-container py-4 px-10 rounded-lg w-[30%]">
        <div className="flex flex-col ">
          <div className="flex justify-center">
            <div className="text-[20px] font-bold">Create new ticket</div>
          </div>

          <div className="flex justify-center items-center mt-6">
            <p className="text-[13px] mr-1">For</p>
            <img
              src={createNewTicket_image}
              alt="profile pic"
              className="w-20 rounded-full"
            />
          </div>

          <div className="mt-6 text-[12px] text-[#828282]">Assign to</div>
          <div>
            <select
              value={followUp}
              onChange={(e) => setFollowUp(e.target.value)}
              className="border border-[#2F80ED] p-2 w-full rounded-lg text-[14px]"
            >
              <option value="" disabled hidden className="text-[#667085]">
                Search & select the person
              </option>
              <option value="email" className="text-[12px]">
                Rahul Gupta
              </option>
              <option value="whatsaap" className="text-[12px]">
                Prveen sharma
              </option>
            </select>
          </div>

          <div>
            <p className="text-[14px] text-[#828282] mt-4">Ticket Title</p>
            <input
              type="text"
              placeholder="Enter the title here"
              className="text-[16px] border w-full border-[#95C2FF] p-2 rounded-lg"
            />

            <p className="text-[14px] text-[#828282] mt-4">Description</p>
            <textarea
              type="text"
              placeholder="Enter the ticket description here"
              className="text-[16px] border w-full h-32 border-[#95C2FF] p-2 rounded-lg"
            />
          </div>
          <div className="flex mt-2">
            <img
              src={attachment_pin_02}
              alt="attachment"
              className="object-contain w-6"
            />
            <img
              src={calender_icon}
              alt="calender"
              className="object-contain w-6 ml-1"
            />
          </div>
          <div className="flex justify-between my-5">
            <button
              className="w-6/12 bg-white text-[#2F80ED] font-bold border border-[#95C2FF] p-2 rounded-lg"
              onClick={() => setNewTicket(false)}
            >
              Discard
            </button>
            <button
              className="w-6/12 bg-[#2F80ED] ml-2 p-2 text-white rounded-lg"
              onClick={() => setNewTicket(false)}
            >
              Send
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateNewTicket;
